// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__ufH29","active":"SwitchDate_active__8BEZT"};